import Dagre from "@dagrejs/dagre";
import { Node, Edge } from "@xyflow/react";
import { ILayoutService, LayoutResult } from "./ILayoutService";

export type LayoutOptions = {
  direction: string;
};

export class DagreLayoutService implements ILayoutService {
  constructor(private options: LayoutOptions) { }

  getLayoutedElements<
    T extends Record<string, unknown>,
    E extends Record<string, unknown>
  >(nodes: Node<T>[], edges: Edge<E>[]): LayoutResult<T, E> {
    // Create a fresh graph per call to avoid stale nodes/edges from previous layouts
    const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
    g.setGraph({ rankdir: this.options.direction });

    edges.forEach((edge) => g.setEdge(edge.source, edge.target));
    nodes.forEach((node) => g.setNode(node.id, node as any));

    Dagre.layout(g);

    return {
      nodes: nodes.map((node) => {
        const n = g.node(node.id);
        return { ...node, position: { x: n.x, y: n.y } } as Node<T>;
      }),
      edges,
    };
  }
}
